import clsx from "clsx";
import { getFilePath } from "../../../utils";
import { MAX_CONTAINER_WIDTH } from "./constants";
import { SectionTitle } from "./SectionTitle";
import { ExpandableCourseList } from "./ExpandableCourseList";
import { ResponsiveImage } from "../ResponsiveImage";
import { usePublishedCoursesQuery } from "./usePublishedCoursesQuery";
import { BlingIcon } from "./BlingIcon";

export const PrepCoursesList: React.FC = () => {
  const { data: courseData } = usePublishedCoursesQuery();

  const prepCourseGroup = courseData?.groups?.find((group) =>
    group.name.toLowerCase().includes("prep")
  );
  const prepCourses = courseData?.courses?.filter(
    (course) => course.groupId === prepCourseGroup?._id
  );
  const featuredCourses = prepCourses
    ?.filter((c) => c.featuredCourseOrder !== undefined)
    .sort(
      (a, b) => (a.featuredCourseOrder ?? 0) - (b.featuredCourseOrder ?? 0)
    );

  return (
    <section className="relative flex w-full justify-center">
      <div
        className={clsx(
          "relative z-10 flex w-full flex-col items-center px-4 md:px-6 xl:px-0",
          MAX_CONTAINER_WIDTH
        )}
      >
        <SectionTitle
          title="Now Featuring New Prep Courses!"
          subtitle="Discover our new Prep Courses! Created to give students practice to get ahead of their math courses next school year!"
          linebreak
        />

        <ExpandableCourseList
          courseGroups={courseData?.groups}
          getCourses={(isExpanded) =>
            isExpanded ? prepCourses : featuredCourses
          }
          getButtonText={(isExpanded) =>
            isExpanded ? "Hide Prep Courses" : "Explore All Prep Courses"
          }
          courseCardBanner="Recommended for Summer"
        />

        <BlingIcon className="absolute -top-[44px] left-1/2 ml-[180px] hidden text-dm-brand-blue-600 sm:block md:-top-[40px] md:ml-[274px]" />
      </div>

      <div className="absolute left-0 top-0 h-full w-full overflow-hidden">
        <ResponsiveImage
          className="absolute -left-[34px] top-[130px] z-20 hidden translate-x-0 lg:block xl:left-auto xl:right-1/2 xl:-translate-x-[548px]"
          srcs={[
            getFilePath("/images/learner/home/cap-small.png"),
            getFilePath("/images/learner/home/cap-small@2x.png"),
          ]}
          alt="Graduation Cap"
        />
        <ResponsiveImage
          className="absolute -right-[15px] bottom-0 z-20 hidden md:block xl:left-1/2 xl:right-auto xl:translate-x-[539px]"
          srcs={[
            getFilePath("/images/learner/home/papers.png"),
            getFilePath("/images/learner/home/papers@2x.png"),
          ]}
          alt="A Stack of Papers"
        />
      </div>
    </section>
  );
};
